import { storeStateService } from 'state/store.state.service';
import { useObservable } from '../observable';

export const useStoreState = () => {
  return {
    storeTheme: useObservable(storeStateService.storeTheme),
    sendEvent: useObservable(storeStateService.sendEvent),
    setStoreTheme: storeStateService.setStoreTheme,
    setSendEvent: storeStateService.setSendEvent,
  };
};
